var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import { useState } from 'react';
import { Layout, CustomLayer, Variant } from '@mademine/components';
import { useI18n } from '@mademine/hooks';
import { I18n, Gtag } from '@mademine/utils';
import Button from '../components/Button';
import en_US from '../lang/en_US.json';
import de_DE from '../lang/de_DE.json';
import fr_FR from '../lang/fr_FR.json';
import it_IT from '../lang/it_IT.json';
import es_ES from '../lang/es_ES.json';
import ja_JP from '../lang/ja_JP.json';
import pt_BR from '../lang/pt_BR.json';
import nl_NL from '../lang/nl_NL.json';
import Custom from './Custom';
import { findSelectedColor } from '../utils';
import styles from './style.module.less';
import '../index.css';
import classNames from 'classnames';
Gtag.setCategory('sunzi-mini-me-double-people');
var App = function (props) {
    var shop = props.shop, _a = props.productType, productType = _a === void 0 ? 'mini-me' : _a, _b = props.balloonVariantFlatImage, balloonVariantFlatImage = _b === void 0 ? false : _b, _c = props.balloonVariantFlatTag, balloonVariantFlatTag = _c === void 0 ? false : _c, styleData = props.styleData, sizeData = props.sizeData, stickerData = props.stickerData, peopleNumber = props.peopleNumber, colors = props.colors, selectedSkinColor = props.selectedSkinColor, guideImage = props.guideImage, textInputSettings = props.textInputSettings, onVariantChange = props.onVariantChange;
    useI18n(shop.language, {
        en_US: en_US,
        de_DE: de_DE,
        fr_FR: fr_FR,
        it_IT: it_IT,
        es_ES: es_ES,
        ja_JP: ja_JP,
        nl_NL: nl_NL,
        pt_BR: pt_BR
    });
    var _d = useState(false), customLayerVisible = _d[0], setCustomLayerVisible = _d[1];
    var _e = useState(sizeData.options.find(function (item) { return item.isSelected; }) ||
        sizeData.options[0] || { id: '', name: '' }), currentSize = _e[0], setCurrentSize = _e[1];
    var _f = useState((styleData && styleData.options.find(function (item) { return item.isSelected; })) ||
        (styleData && styleData.options[0]) || { id: '', name: '' }), currentStyle = _f[0], setCurrentStyle = _f[1];
    var _g = useState(findSelectedColor(colors, selectedSkinColor, peopleNumber || 1)), currentColor = _g[0], setCurrentColor = _g[1];
    var handleChangeColor = function (item, index) {
        currentColor[index] = item;
        setCurrentColor(__spreadArray([], currentColor, true));
    };
    var handleChangeSize = function (item) {
        var result = sizeData.options.find(function (size) { return size.id === item; });
        if (result) {
            setCurrentSize(result);
            onVariantChange('size', result.name);
        }
    };
    var handleChangeBallonStyle = function (item) {
        var result = styleData === null || styleData === void 0 ? void 0 : styleData.options.find(function (style) { return style.id === item; });
        if (result) {
            setCurrentStyle(result);
            onVariantChange('style', result.name);
        }
    };
    var renderVariantOptions = function (options, currentValue, onChange) {
        if (productType === 'balloon' && balloonVariantFlatImage) {
            return options.map(function (item, index) {
                var _a;
                return (_jsx(Variant.Image, { className: "!_sz-mx-0 _sz-p-0 _sz-w-auto", onClick: function () { return onChange(item.id); }, title: item.name, image: (_a = item.image) !== null && _a !== void 0 ? _a : 'https://sunzi7n.myuxc.com/clay-figurine/2024913/0cc8fc91-8dfb-46e4-9c6a-0f5c1e9eeede-0-handle.jpg', active: currentValue === item.id }, index));
            });
        }
        if (productType === 'balloon' && balloonVariantFlatTag) {
            return options.map(function (item, index) { return (_jsx(Variant.Tag, { className: "!_sz-mx-0 _sz-p-0 ", onClick: function () { return onChange(item.id); }, title: item.name, active: currentValue === item.id }, index)); });
        }
        return (_jsx(Variant.Select, { className: "!_sz-mx-0", options: options, value: currentValue, onChange: onChange }));
    };
    return (_jsx(Layout, { theme: shop.theme, enableSecurity: false, children: _jsxs("div", { className: "sunzi-mini-me-double-people", children: [!textInputSettings && (_jsxs(_Fragment, { children: [productType === 'balloon' &&
                            styleData &&
                            styleData.options.length > 1 && (_jsx(Variant, { contentStyle: {
                                color: 'red',
                                flexWrap: 'wrap',
                                gap: '14px'
                            }, title: styleData.title, className: styles.variant, children: renderVariantOptions(styleData.options, currentStyle.id, handleChangeBallonStyle) })), sizeData.options.length > 1 && (_jsx(Variant, { contentStyle: { color: 'red', flexWrap: 'wrap', gap: '14px' }, title: sizeData.title, className: styles.variant, children: renderVariantOptions(sizeData.options, currentSize.id, handleChangeSize) })), peopleNumber !== undefined ? (_jsxs("div", { className: "_sz-pt-[18px] _sz-pb-8", children: [_jsx("h1", { className: "_sz-m-0  _sz-mb-1 _sz-p-0 _sz-text-base _sz-font-extrabold _sz-leading-[22px] _sz-text-black/[.88]", children: I18n.format('modules.mini.me.choose.skin.color.title') }), _jsx("p", { className: "_sz-m-0  _sz-p-0 _sz-text-xs _sz-leading-[14px]", children: I18n.format('modules.mini.me.choose.skin.color.title.description') }), new Array(peopleNumber)
                                    .fill(undefined)
                                    .map(function (_, colorListIndex) { return (_jsx(Variant, { title: I18n.format('variant.skin.color', {
                                        value: peopleNumber > 1 ? "".concat(colorListIndex + 1) : ''
                                    }), className: classNames(styles.variant, styles['color-variants']), children: colors
                                        .filter(function (item) {
                                        return item.belongPeople === undefined
                                            ? true
                                            : item.belongPeople === colorListIndex;
                                    })
                                        .map(function (item) {
                                        var _a;
                                        return (_jsx(Variant.Color, { color: item.color, className: 'first:_sz-pl-0', contentClassName: classNames('!_sz-w-20	!_sz-h-10 !_sz-rounded after:!_sz-rounded', (_a = {},
                                                _a['after:!_sz-border-[var(--sunzi-theme-color)]'] = currentColor[colorListIndex].name ===
                                                    item.name,
                                                _a)), active: currentColor[colorListIndex].name === item.name, onClick: function () {
                                                handleChangeColor(item, colorListIndex);
                                            } }, item.name));
                                    }) }, colorListIndex)); })] })) : (_jsx(Variant, { title: I18n.format('modules.mini.me.choose.skin.color.title'), className: "{styles.variant}", children: colors.map(function (item) { return (_jsx(Variant.Color, { color: item.color, className: "{styles.circleItem}", contentClassName: "_sz-w-20\t_sz-h-10", active: currentColor[0].name === item.name, onClick: function () { return handleChangeColor(item, 0); } }, item.name)); }) }))] })), _jsx(Button, { type: "theme", onClick: function () { return setCustomLayerVisible(true); }, children: I18n.format('customize.now') }), customLayerVisible && (_jsx(CustomLayer, { className: "sunzi-mini-me-double-people", children: _jsx(Custom, __assign({}, props, { selectedColor: currentColor, setSelectedColor: setCurrentColor, selectedSize: currentSize, setCurrentSize: setCurrentSize, onClose: function () {
                            setCustomLayerVisible(false);
                            if (props.onClose)
                                props.onClose();
                        } })) }))] }) }));
};
function render(Component, props, matomoId, element) {
    var root = createRoot(element);
    var childrenNode = _jsx(Component, __assign({}, props));
    root.render(childrenNode);
}
export { render };
export default App;
export var TaskStatus;
(function (TaskStatus) {
    TaskStatus[TaskStatus["Recognition"] = 0] = "Recognition";
    TaskStatus[TaskStatus["NetworkError"] = 1] = "NetworkError";
    TaskStatus[TaskStatus["CropError"] = 2] = "CropError";
    TaskStatus[TaskStatus["ChooseAvatar"] = 3] = "ChooseAvatar";
    TaskStatus[TaskStatus["Choose"] = 4] = "Choose";
    TaskStatus[TaskStatus["Preview"] = 5] = "Preview";
})(TaskStatus || (TaskStatus = {}));
export var IncrementType;
(function (IncrementType) {
    IncrementType[IncrementType["SameSide"] = -1] = "SameSide";
    IncrementType[IncrementType["DoubleSide"] = 0] = "DoubleSide";
    IncrementType[IncrementType["NewImageSide"] = 1] = "NewImageSide";
})(IncrementType || (IncrementType = {}));
